import * as yup from 'yup';

import i18n from '@app/i18n/config';

export const submitProfileEditSchema = yup.object({
  files: yup.array().when('$isFileRequired', ([isFileRequired], schema) => {
    if (!isFileRequired) return schema;

    return schema
      .required(i18n.t('AGENT_PROFILE:errors.fileRequired'))
      .min(1, i18n.t('AGENT_PROFILE:errors.fileRequired'));
  }),
});
